import {EventEmitter, Injectable} from '@angular/core';
import {Timezone} from '../../Models/Timezone';
declare var require: any;
import {use, ZonedDateTime, ZoneId, ZoneOffset, ZoneRegion} from 'js-joda';
import TIMEZONES from '../../Components/time-selector/timezones';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {CookieService} from 'angular2-cookie/services/cookies.service';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';
use(require('js-joda-timezone'));

window['appointmentTimezone'] = '-0500';

// window['appointmentAPIurl'] = 'http://acuityapi.kinsta.com/';
// window['appointmentAPIurl'] = 'https://sharpspring.com/wp-content/plugins/acuity-scheduling-angular/api/';
window['appointmentAPIurl'] = '/wp-content/plugins/acuity-scheduling-angular/api/';

@Injectable()
export class TimezoneService {

  timezone: any = {};
  openTimeZone: BehaviorSubject<any>;

  timezonelist: Array<any> = [];

  constructor(private http: Http) {
    this.http = http;

    // use TimeZone of User
    // window['appointmentTimezone'] = ZonedDateTime.now().offset()._id.split(':')[0] + '00' || '-0500';
    const cookieTimezone = CookieService.prototype.get('appointmentDate');
    if (cookieTimezone !== '' && cookieTimezone !== undefined) {
      window['appointmentTimezone'] = cookieTimezone.substr(-5, 5);
    } else {
      // window['appointmentTimezone'] = this.getTrueTimezone().timezone || '-0500'; // timezone without daylight offset
      window['appointmentTimezone'] = new Date().toString().split('GMT')[1].substr(0, 5) || '-0500'; // timezone from user PC
    }

    this.getTimezones().subscribe((response) => {
      const midway = response[0];
      delete response[0];
      response.splice(7, 0, midway);

      for (const tz in response) {
        response[tz].gmt  = response[tz].gmt + ':00';
        if (response[tz].zone !== undefined) {
          response[tz].zone  = response[tz].zone
            .replace('AKST, ', '')
            .replace('PST, ', '')
            .replace('MST, ', '')
            .replace('CST, ', '')
            .replace('EST, ', '')
            .replace('AST, ', '')
            .replace('CET, ', '');
          response[tz].zone = response[tz].zone.split(',')[0];
        }
        this.timezonelist.push(response[tz]);

        if ( response[tz].time === window['appointmentTimezone'] ) {
          this.timezone = response[tz];
          this.setZoneId();
          this.setRegion();
          // this.timezone.zoneId = ZoneId.ofOffset("GMT", ZoneOffset.of( response[tz].time.slice(0, 3) ));
          // this.timezone.region = ZoneRegion.ofOffset("GMT", ZoneOffset.of( response[tz].time.slice(0, 3) ));
          this.openTimeZone = new BehaviorSubject(this.timezone);
        }
      }
    });

    // timezone from appointmentTimezone
    // let curDate = new Date().toISOString().split('.')[0] + window["appointmentTimezone"].substr(0, 3) + ":00";
    // let zdtOffset = ZonedDateTime.parse( curDate ).offset();
    // let nowZone = ZoneRegion.ofOffset("UTC", zdtOffset);
    ////// OLD let nowZone = ZoneRegion.ofOffset("UTC", ZonedDateTime.now().offset());

    // for (let timezone of TIMEZONES) {
    //   let tzOffset = ZoneOffset.of(timezone.offset.slice(3));
    //   if (ZoneRegion.ofOffset("UTC", tzOffset).equals(nowZone)) {
    //     this.timezone = timezone;
    //   }
    // }
    // this.openTimeZone = new BehaviorSubject(this.timezone);
  }

  getTrueTimezone() {
    const rightNow = new Date();
    const jan1 = new Date(rightNow.getFullYear(), 0, 1, 0, 0, 0, 0);
    let temp = jan1['toGMTString']();
    const jan2 = new Date(temp.substring(0, temp.lastIndexOf(' ') - 1));
    let std_time_offset = (jan1.getTime() - jan2.getTime()) / (1000 * 60 * 60);

    const june1 = new Date(rightNow.getFullYear(), 6, 1, 0, 0, 0, 0);
    temp = june1['toGMTString']();
    const june2 = new Date(temp.substring(0, temp.lastIndexOf(' ') - 1));
    const daylight_time_offset = (june1.getTime() - june2.getTime()) / (1000 * 60 * 60);
    let dst;
    if (std_time_offset === daylight_time_offset) {
        dst = 0; // regular time
    } else {
        dst = 1; // summer time
    }
    std_time_offset *= 100;
    if ( std_time_offset % 100 === 75 || std_time_offset % 100 === -75 ) {
      std_time_offset += 25;
    }
    if ( std_time_offset % 100 === 50 ) {
      std_time_offset -= 20;
    }
    if ( std_time_offset % 100 === -50 ) {
      std_time_offset += 20;
    }
    const abs_std_time_offset = Math.abs( std_time_offset );
    let formatted;
    if ( abs_std_time_offset < 1000 ) {
      formatted = '0' + abs_std_time_offset;
    } else {
      formatted = '' + abs_std_time_offset;
    }
    if ( std_time_offset < 0 ) {
      formatted = '-' + formatted;
    } else {
      formatted = '+' + formatted;
    }
    return { timezone: formatted, dst: dst }
  }

  setZoneId() {
    this.timezone.zoneId = ZoneId.ofOffset('GMT', ZoneOffset.of( this.timezone.time.slice(0, 3) ));
  }
  setRegion() {
    this.timezone.region = ZoneRegion.ofOffset('GMT', ZoneOffset.of( this.timezone.time.slice(0, 3) ));
  }

  getTimezones(): Observable<any> {
    return this.http.get(window['appointmentAPIurl'] + 'get_timezones.php?apt_id=' + window['appointmentType'])
      .map((response) => {
        return JSON.parse(response['_body']);
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/Services/timezone/timezone.service.ts